// extracted by mini-css-extract-plugin
export default {"wrapper":"docsSpinner_wrapper__pKiLx","spinner":"docsSpinner_spinner__ryZ-c","docsSpin":"docsSpinner_docsSpin__iWwoy"};